import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Helmet } from "react-helmet";
import { ModalStatus, ModalTypes, setModalType, setStatus as setModalStatus, showModal } from "store/actions/modal";

import { getInstance as getStore } from "store/store";

import "./landing.less";
import { setPromotionPopupVisibilityStatus } from "../../../store/actions/promotionpopupconfig";

import BlockTypes from "../newLandingPage/block-types";
import BlockSlider from "../newLandingPage/block-slider";
import BlockDevices from "../newLandingPage/block-devices";

import BlockStart from "../newLandingPage/block-start";
import BlockCategories from "../newLandingPage/block-categories";
import Ellipse from "./assets/ellipse.png";


class Landing extends React.Component {
  constructor(...args) {
    super(...args);
  }

  openPromotionPopup() {
    const store = getStore();

    const modalStore = store.getState().modal;

    if (modalStore.show) return;

    store.dispatch(setModalStatus(ModalStatus.SHOW));
    store.dispatch(setModalType(ModalTypes.PROMOTION_POPUP));
    store.dispatch(showModal());
    store.dispatch(setPromotionPopupVisibilityStatus(true));
  }

  renderLandingPage() {
    const { loginRedirectionURL, registrationRedirectionURL } = this.props;

    let {
        landingPage,
      } = this.props,
      { landingPage: landingPageData } = landingPage,
      { collage, devices, faq, callToAction } = landingPageData;

    const { promotionPopupConfig: { title, isVisible }, splashScreen: {splashScreenVisibilityStatus} } = getStore().getState();


    if (title && !isVisible) {
      this.openPromotionPopup();
    }
    return (
      <div className="landing">
        <Helmet>
          <title>
            ביגי - עולם ענק ומרגש של תוכן איכותי ומרגש לילדים ונוער
          </title>
          <meta
            name="description"
            content="אפליקציית תוכן לילדים ונוער. עולם סגור ובטוח עם מגוון רחב של תכני ערוץ הילדים, לוגי ויויו"
          />
        </Helmet>
        <BlockStart
          splashScreenVisibilityStatus={splashScreenVisibilityStatus}
          loginRedirectionURL={loginRedirectionURL}
          registrationRedirectionURL={registrationRedirectionURL}
        />
        <BlockSlider registrationRedirectionURL={registrationRedirectionURL} />
        <BlockDevices
          registrationRedirectionURL={registrationRedirectionURL}
        />
        <BlockCategories
          registrationRedirectionURL={registrationRedirectionURL}
        />
        <BlockTypes registrationRedirectionURL={registrationRedirectionURL} />
        <img className="landing__ellipse" src={Ellipse} alt="ellipse" />
      </div>
    );

  }

  render() {
    return this.renderLandingPage();
  }
}

Landing.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  registrationRedirectionURL: PropTypes.bool.isRequired,
  loginRedirectionURL: PropTypes.bool.isRequired,
};

Landing.contextTypes = {
  t: PropTypes.func,
};

const mapStateToProps = (state) => ({
  loginRedirectionURL: state.config.seaChange.login,
  registrationRedirectionURL: state.config.seaChange.registration,
  splashScreenVisibilityStatus: state.splashScreen.splashScreenVisibilityStatus,
});

export default connect(mapStateToProps, null)(Landing);



// WEBPACK FOOTER //
// ./src/js/components/pages/landing/landing.jsx